import aa from '../projectimg/aa.png'
import bb from '../projectimg/bb.png'
import cc from '../projectimg/cc.png'
import dd from '../projectimg/dd.png'
import ee from '../projectimg/ee.png'
import ff from '../projectimg/ff.png'
import gg from '../projectimg/gg.png'
import hh from '../projectimg/hh.png'
import jj from '../projectimg/jj.png'
import kk from '../projectimg/kk.png'
import ll from '../projectimg/ll.png'
import mm from '../projectimg/mm.png'
import nn from '../projectimg/nn.PNG'
import oo from '../projectimg/oo.png'
import pp from '../projectimg/pp.png'

export const ProjectList = [
       { name:'Gericht Restuarant', image: aa, sk: 'A modern German Restaurant website using React-js & React Hooks & clean code with responsive design and easy to use with wonderful UI' ,
        eurl: 'https://moamen-fayez.github.io/gericht-restaurant/'},


        {name:'React Dashboard', image:bb, sk: 'A whole React admin dashboard app, possibility to choose between 6 colors, as well as toggle between dark and white mode, and fully functional charts, pages, calendar and possibility to edit, delete, sort and drag and drop items' ,
         eurl: 'https://moamen-fayez.github.io/dashboard/'},


         {name:'Wordle', image:cc , sk: 'A React js Project with a lot of logic, but every Part of code is understandable, It is the learning experience' ,
          eurl: 'https://moamen-fayez.github.io/wordle/'},


         {name:'Todo list', image:dd , sk: 'Created with React hooks, easy to use, with wonderful UI' ,
          eurl: 'https://moamen-fayez.github.io/React-todo-list/'},


         {name:'Tic Tac Toe', image:ee, sk: 'A small website with a lot of beautiful logic using Reactjs' ,
          eurl: 'https://moamen-fayez.github.io/tic-tac-toe/'},


         {name:'Recipe app', image:ff, sk: 'Built using React Hooks & api and possibility to search between delicious food recipe, yummy!' ,
          eurl: 'https://moamen-fayez.github.io/recipe-app/'},


         {name:'FilmLand', image:gg, sk: 'A small faster React app, to practice using Api with Reactjs and possibility to search between Films' ,
          eurl: 'https://moamen-fayez.github.io/react-film/'},


         {name:'football matches results', image: hh , sk: 'Built using React Hooks, API and simple User Interface' ,
          eurl: 'https://moamen-fayez.github.io/football-news/'},


         {name:'Cryptocurrency', image: jj, sk: 'A cryptocurrency React-js app, using Api, React Hooks, and possibility to search between different Coins, responsive design friendly and easy to use' ,
          eurl: 'https://moamen-fayez.github.io/my-app/'},


         {name:'Calculator', image: kk, sk: 'Simple logical calculator using Reactjs' ,
          eurl: 'https://moamen-fayez.github.io/React-Calculator/'},


         {name:'Cairo Guide', image: ll, sk: 'The idea for this site has been in my mind for a while, from my thinking, I designed and built this Website using HTML and CSS' ,
          eurl: 'https://moamen-fayez.github.io/cairo-districts-/'},


         {name:'Periodic table', image: mm, sk: 'Periodic table, simple, but my own idea and design, only HTML & CSS' ,
          eurl: 'https://moamen-fayez.github.io/educational-tutorial/'},


         {name:'Weather app', image: nn, sk: 'Possibility to search between our international beautiful cities, the background changes depending on the temperature' ,
          eurl: 'https://moamen-fayez.github.io/react-weather-app/'},


         {name:'leon template', image: oo, sk: 'I built this site using HTML & CSS only, The idea is not my own, but I just imitate it with my own Code' ,
          eurl: 'https://moamen-fayez.github.io/tem.-num-1/'},


        { name:'kitten lover app', image: pp, sk: 'A simple React Api app, if you love the Cats like me, you will love this Website, enjoy!' ,
         eurl: 'https://moamen-fayez.github.io/kitten-lover/'}
]